/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  GetGroups200ResponseInner,
  InternalServerError,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    GetGroups200ResponseInnerFromJSON,
    GetGroups200ResponseInnerToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
} from '../models/index';

export interface GetGroupsRequest {
    sort?: GetGroupsSortEnum;
}

/**
 * 
 */
export class GroupsApi extends runtime.BaseAPI {

    /**
     * グループ一覧情報取得
     */
    async getGroupsRaw(requestParameters: GetGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetGroups200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetGroups200ResponseInnerFromJSON));
    }

    /**
     * グループ一覧情報取得
     */
    async getGroups(requestParameters: GetGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetGroups200ResponseInner>> {
        const response = await this.getGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetGroupsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetGroupsSortEnum = typeof GetGroupsSortEnum[keyof typeof GetGroupsSortEnum];
